import { HTTP } from '@/http-common'

function getClaim (claimId) {
  return HTTP.get('/claims/' + claimId)
}

function addClaim (claimData) {
  let data = JSON.stringify(claimData)

  return HTTP.post('/claims', data, {
    headers: {
      'Content-Type': 'application/json; charset=utf-8'
    }
  })
}

function updateClaim (claimData) {
  let data = JSON.stringify(claimData)

  return HTTP.put('/claims/' + claimData.id, data, {
    headers: {
      'Content-Type': 'application/json; charset=utf-8'
    }
  })
}

function deleteClaim (claimId) {
  return HTTP.delete('/claims/' + claimId)
}

export { getClaim, addClaim, updateClaim, deleteClaim }



// WEBPACK FOOTER //
// ./src/services/claim.service.js